module.exports = "/_next/static/images/visacard-line-e394242236ebbb672d37e481d1614a8d.svg";